import { FormattedMessage, useIntl } from "react-intl";

import UFOSegment from "@atlaskit/react-ufo/segment";

import { DEFAULT_VALUES } from "@/libraries/web-framework/src/localization/values";
import { ProductKeyTypes } from "@/libraries/wpl/foundations/src/data-event-props";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";

import {
    EnhancedBannerAlert,
    EnhancedBannerProps
} from "./enhanced-banner-alert";

const AcquisitionAnnouncementDetail = () => (
    <FormattedMessage
        id="BannerAlert.gwp-8238-announcement.event-details"
        defaultMessage="<strong>Breaking news:</strong> DX to join Atlassian!"
        values={DEFAULT_VALUES}
    />
);

interface GWP8238BannerProps {
    productKey: ProductKeyTypes;
    identifier: string;
    ufoSegmentName: string;
    testId: string;
    linkTextId?: string;
    linkTextDefault?: string;
}

export const GWP8238AcquisitionBanner = ({
    productKey,
    identifier,
    ufoSegmentName,
    testId,
    linkTextId = "BannerAlert.gwp-8238-announcement.link-text",
    linkTextDefault = "Learn more"
}: GWP8238BannerProps) => {
    const intl = useIntl();

    if (!checkFeatureFlagGate(featureFlags.gwp8238BannerAnnouncement)) {
        return null;
    }

    const linkText = intl.formatMessage({
        id: linkTextId,
        defaultMessage: linkTextDefault
    });

    const acquisitionAnnouncementConfig: EnhancedBannerProps = {
        imageProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        imageMobileProps: {
            src: "https://dam-cdn.atl.orangelogic.com/AssetLink/v8lbu3715h6ef46x68cmh3tl207d4l74.svg",
            alt: "DX",
            width: 50
        },
        identifier,
        text: (
            <>
                <AcquisitionAnnouncementDetail />
                <span data-testid={testId} />
            </>
        ),
        mobileText: <AcquisitionAnnouncementDetail />,
        productKey,
        backgroundPreset: "gwp-8238-announcement",
        linkText,
        linkUrl:
            "https://www.atlassian.com/blog/announcements/atlassian-acquires-dx",
        dataEventProps: {
            "data-product-key": productKey,
            "data-event-component": "linkButton",
            "data-event-container": "announcementBanner",
            "data-event": "clicked",
            "data-label": linkText,
            "data-label-english": "Learn more"
        }
    };

    return (
        <UFOSegment name={ufoSegmentName}>
            <EnhancedBannerAlert {...acquisitionAnnouncementConfig} />
        </UFOSegment>
    );
};
